module.exports = __webpack_public_path__ + "img/inco4Ac.008edf98.png";